import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  Radio,
  Collapse,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';

// Add Node Dialog
export class AddNodeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameDe: '',
      nameEn: '',
      nameFr: '',
      selectedUserGroups: []
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      // Reset state when dialog opens
      this.setState({
        nameDe: '',
        nameEn: '',
        nameFr: '',
        selectedUserGroups: []
      });
    }
  }

  handleUserGroupToggle = (groupId) => {
    const { selectedUserGroups } = this.state;
    const currentIndex = selectedUserGroups.indexOf(groupId);
    const newSelected = [...selectedUserGroups];

    if (currentIndex === -1) {
      newSelected.push(groupId);
    } else {
      newSelected.splice(currentIndex, 1);
    }

    this.setState({ selectedUserGroups: newSelected });
  };

  handleSubmit = () => {
    const { nameDe, nameEn, nameFr, selectedUserGroups } = this.state;
    
    if (!nameDe.trim()) {
      alert('Bitte geben Sie mindestens einen deutschen Namen ein.');
      return;
    }

    this.props.onSubmit({
      names: [
        { lang: 'DE', value: nameDe },
        { lang: 'EN', value: nameEn || nameDe },
        { lang: 'FR', value: nameFr || nameDe }
      ],
      userGroupIds: selectedUserGroups
    });
  };

  render() {
    const { open, onClose, userGroups = [] } = this.props;
    const { nameDe, nameEn, nameFr, selectedUserGroups } = this.state;

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Neuen Ordner hinzufügen</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name (Deutsch)"
            fullWidth
            value={nameDe}
            onChange={(e) => this.setState({ nameDe: e.target.value })}
            required
          />
          <TextField
            margin="dense"
            label="Name (English)"
            fullWidth
            value={nameEn}
            onChange={(e) => this.setState({ nameEn: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Name (Français)"
            fullWidth
            value={nameFr}
            onChange={(e) => this.setState({ nameFr: e.target.value })}
          />
          
          <Typography variant="subtitle1" style={{ marginTop: 16, marginBottom: 8 }}>
            Berechtigungen für Benutzergruppen:
          </Typography>
          
          {userGroups.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Keine Benutzergruppen verfügbar
            </Typography>
          ) : (
            <List dense>
              {userGroups.map((group) => {
                const nameDe = group.names && group.names.find(n => n.lang === 'DE');
                const groupName = nameDe ? nameDe.value : group.id;
                
                return (
                  <ListItem key={group.id} button onClick={() => this.handleUserGroupToggle(group.id)}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedUserGroups.indexOf(group.id) !== -1}
                          onChange={() => this.handleUserGroupToggle(group.id)}
                        />
                      }
                      label={groupName}
                    />
                  </ListItem>
                );
              })}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            Abbrechen
          </Button>
          <Button onClick={this.handleSubmit} color="primary" variant="contained">
            Hinzufügen
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// Rename Node Dialog
export class RenameNodeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameDe: '',
      nameEn: '',
      nameFr: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open && this.props.node) {
      // Populate with current names
      const node = this.props.node;
      const namesDe = node.names && node.names.find(n => n.lang === 'DE');
      const namesEn = node.names && node.names.find(n => n.lang === 'EN');
      const namesFr = node.names && node.names.find(n => n.lang === 'FR');
      
      this.setState({
        nameDe: namesDe ? namesDe.value : '',
        nameEn: namesEn ? namesEn.value : '',
        nameFr: namesFr ? namesFr.value : ''
      });
    }
  }

  handleSubmit = () => {
    const { nameDe, nameEn, nameFr } = this.state;
    
    if (!nameDe.trim()) {
      alert('Bitte geben Sie mindestens einen deutschen Namen ein.');
      return;
    }

    this.props.onSubmit({
      names: [
        { lang: 'DE', value: nameDe },
        { lang: 'EN', value: nameEn || nameDe },
        { lang: 'FR', value: nameFr || nameDe }
      ]
    });
  };

  render() {
    const { open, onClose, node } = this.props;
    const { nameDe, nameEn, nameFr } = this.state;

    if (!node) return null;

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Ordner umbenennen</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name (Deutsch)"
            fullWidth
            value={nameDe}
            onChange={(e) => this.setState({ nameDe: e.target.value })}
            required
          />
          <TextField
            margin="dense"
            label="Name (English)"
            fullWidth
            value={nameEn}
            onChange={(e) => this.setState({ nameEn: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Name (Français)"
            fullWidth
            value={nameFr}
            onChange={(e) => this.setState({ nameFr: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            Abbrechen
          </Button>
          <Button onClick={this.handleSubmit} color="primary" variant="contained">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// Delete Node Dialog
export class DeleteNodeDialog extends Component {
  render() {
    const { open, onClose, onConfirm, node } = this.props;

    if (!node) return null;

    const nameDe = node.names && node.names.find(n => n.lang === 'DE');
    const nodeName = nameDe ? nameDe.value : node.id;

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Ordner löschen</DialogTitle>
        <DialogContent>
          <Typography>
            Möchten Sie den Ordner "{nodeName}" wirklich löschen?
          </Typography>
          <Typography variant="body2" color="error" style={{ marginTop: 16 }}>
            Warnung: Diese Aktion kann nicht rückgängig gemacht werden. 
            Alle Unterordner und Dateien in diesem Ordner werden ebenfalls gelöscht.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            Abbrechen
          </Button>
          <Button onClick={onConfirm} color="secondary" variant="contained">
            Löschen
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// Permissions Dialog
export class PermissionsDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUserGroups: []
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open && this.props.node) {
      // Load current permissions
      const permissions = this.props.node.permissions || [];
      this.setState({
        selectedUserGroups: permissions.map(p => p.userGroupId)
      });
    }
  }

  handleUserGroupToggle = (groupId) => {
    const { selectedUserGroups } = this.state;
    const currentIndex = selectedUserGroups.indexOf(groupId);
    const newSelected = [...selectedUserGroups];

    if (currentIndex === -1) {
      newSelected.push(groupId);
    } else {
      newSelected.splice(currentIndex, 1);
    }

    this.setState({ selectedUserGroups: newSelected });
  };

  handleSubmit = () => {
    this.props.onSubmit({
      userGroupIds: this.state.selectedUserGroups
    });
  };

  render() {
    const { open, onClose, node, userGroups = [] } = this.props;
    const { selectedUserGroups } = this.state;

    if (!node) return null;

    const nameDe = node.names && node.names.find(n => n.lang === 'DE');
    const nodeName = nameDe ? nameDe.value : node.id;

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Berechtigungen anpassen: {nodeName}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom>
            Wählen Sie die Benutzergruppen aus, die Zugriff auf diesen Ordner haben sollen:
          </Typography>
          
          {userGroups.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Keine Benutzergruppen verfügbar
            </Typography>
          ) : (
            <List dense>
              {userGroups.map((group) => {
                const groupNameDe = group.names && group.names.find(n => n.lang === 'DE');
                const groupName = groupNameDe ? groupNameDe.value : group.id;
                
                return (
                  <ListItem key={group.id} button onClick={() => this.handleUserGroupToggle(group.id)}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedUserGroups.indexOf(group.id) !== -1}
                          onChange={() => this.handleUserGroupToggle(group.id)}
                        />
                      }
                      label={groupName}
                    />
                  </ListItem>
                );
              })}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            Abbrechen
          </Button>
          <Button onClick={this.handleSubmit} color="primary" variant="contained">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// Move Node Dialog
export class MoveNodeDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedParentId: '',
      expandedNodes: {},
      draggedOver: null
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      // Auto-expand all nodes when dialog opens
      const { availableNodes = [] } = this.props;
      const expanded = {};
      availableNodes.forEach(node => {
        if (node.hasChildren) {
          expanded[node.id] = true;
        }
      });
      this.setState({ 
        selectedParentId: '',
        expandedNodes: expanded,
        draggedOver: null
      });
    }
  }

  toggleExpand = (nodeId) => {
    this.setState(prevState => ({
      expandedNodes: {
        ...prevState.expandedNodes,
        [nodeId]: !prevState.expandedNodes[nodeId]
      }
    }));
  };

  handleDragStart = (e, nodeId) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', nodeId);
  };

  handleDragOver = (e, nodeId) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    this.setState({ draggedOver: nodeId });
  };

  handleDragLeave = () => {
    this.setState({ draggedOver: null });
  };

  handleDrop = (e, targetNodeId) => {
    e.preventDefault();
    this.setState({ 
      selectedParentId: targetNodeId,
      draggedOver: null
    });
  };

  buildNodeTree = (nodes, parentId = null) => {
    return nodes.filter(node => node.parentId === parentId);
  };

  renderTreeNode = (node, lang, level = 0) => {
    const { availableNodes = [] } = this.props;
    const { expandedNodes, selectedParentId, draggedOver } = this.state;
    
    const nameEntry = node.names && node.names.find(n => n.lang === lang.toUpperCase());
    const fallbackEntry = node.names && node.names.find(n => n.lang === 'DE');
    const nodeName = nameEntry ? nameEntry.value : (fallbackEntry ? fallbackEntry.value : node.id);
    
    // Check if this node has children
    const children = this.buildNodeTree(availableNodes, node.id);
    const hasChildren = children.length > 0;
    const isExpanded = expandedNodes[node.id];
    const isSelected = selectedParentId === node.id;
    const isDraggedOver = draggedOver === node.id;

    return (
      <div key={node.id} style={{ marginLeft: level * 20 }}>
        <div
          draggable
          onDragStart={(e) => this.handleDragStart(e, node.id)}
          onDragOver={(e) => this.handleDragOver(e, node.id)}
          onDragLeave={this.handleDragLeave}
          onDrop={(e) => this.handleDrop(e, node.id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            cursor: 'pointer',
            backgroundColor: isDraggedOver ? '#e3f2fd' : (isSelected ? '#bbdefb' : 'transparent'),
            border: isDraggedOver ? '2px dashed #2196f3' : '2px solid transparent',
            borderRadius: '4px',
            marginBottom: '2px'
          }}
          onClick={() => this.setState({ selectedParentId: node.id })}
        >
          {hasChildren ? (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                this.toggleExpand(node.id);
              }}
              style={{ padding: 4, marginRight: 4 }}
            >
              {isExpanded ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
            </IconButton>
          ) : (
            <div style={{ width: 32 }} />
          )}
          
          {isExpanded ? (
            <FolderOpenIcon fontSize="small" style={{ marginRight: 8, color: '#ffa726' }} />
          ) : (
            <FolderIcon fontSize="small" style={{ marginRight: 8, color: '#ffa726' }} />
          )}
          
          <Typography
            variant="body2"
            style={{
              flex: 1,
              fontWeight: isSelected ? 'bold' : 'normal'
            }}
          >
            {nodeName}
          </Typography>
          
          <Radio
            checked={isSelected}
            value={node.id}
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              this.setState({ selectedParentId: node.id });
            }}
          />
        </div>
        
        {hasChildren && isExpanded && (
          <Collapse in={isExpanded}>
            <div>
              {children.map(child => this.renderTreeNode(child, lang, level + 1))}
            </div>
          </Collapse>
        )}
      </div>
    );
  };

  handleSubmit = () => {
    const { selectedParentId } = this.state;
    
    if (!selectedParentId) {
      alert('Bitte wählen Sie einen Zielordner aus.');
      return;
    }

    this.props.onSubmit({ newParentId: selectedParentId });
  };

  render() {
    const { open, onClose, node, availableNodes = [], lang = 'de' } = this.props;
    const { selectedParentId } = this.state;

    if (!node) return null;

    const nameDe = node.names && node.names.find(n => n.lang === 'DE');
    const nodeName = nameDe ? nameDe.value : node.id;

    // Filter out the node itself and its descendants
    const filteredNodes = availableNodes.filter(n => n.id !== node.id);
    
    // Build root nodes (nodes without parent or with parentId not in filtered list)
    const rootNodes = this.buildNodeTree(filteredNodes, null);

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Ordner verschieben: {nodeName}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" gutterBottom style={{ marginBottom: 16 }}>
            Wählen Sie den Zielordner aus oder ziehen Sie den Ordner per Drag & Drop:
          </Typography>
          
          {filteredNodes.length === 0 ? (
            <Typography variant="body2" color="textSecondary">
              Keine Zielordner verfügbar
            </Typography>
          ) : (
            <div style={{ 
              border: '1px solid #ddd', 
              borderRadius: '4px', 
              padding: '8px',
              maxHeight: '400px',
              overflowY: 'auto'
            }}>
              {rootNodes.map(node => this.renderTreeNode(node, lang, 0))}
            </div>
          )}
          
          {selectedParentId && (
            <Typography variant="body2" color="primary" style={{ marginTop: 16 }}>
              Ausgewählter Zielordner: {(() => {
                const selectedNode = filteredNodes.find(n => n.id === selectedParentId);
                if (!selectedNode) return selectedParentId;
                const nameEntry = selectedNode.names && selectedNode.names.find(n => n.lang === lang.toUpperCase());
                const fallbackEntry = selectedNode.names && selectedNode.names.find(n => n.lang === 'DE');
                return (nameEntry && nameEntry.value) || (fallbackEntry && fallbackEntry.value) || selectedParentId;
              })()}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            Abbrechen
          </Button>
          <Button onClick={this.handleSubmit} color="primary" variant="contained" disabled={!selectedParentId}>
            Verschieben
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

// Visibility Schedule Dialog
export class VisibilityScheduleDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visibilityFrom: '',
      restrictedGroupId: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      const { node } = this.props;
      const visibilityFrom = node && node.visibilityFrom
        ? new Date(node.visibilityFrom).toISOString().split('T')[0]
        : '';
      this.setState({
        visibilityFrom,
        restrictedGroupId: (node && node.restrictedGroupId) || '',
      });
    }
  }

  handleSubmit = () => {
    const { visibilityFrom, restrictedGroupId } = this.state;
    this.props.onSubmit({
      visibilityFrom: visibilityFrom || null,
      restrictedGroupId: restrictedGroupId || null,
    });
  };

  handleClear = () => {
    this.props.onSubmit({ visibilityFrom: null, restrictedGroupId: null });
  };

  render() {
    const { open, onClose, userGroups = [] } = this.props;
    const { visibilityFrom, restrictedGroupId } = this.state;

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Sichtbarkeit festlegen</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
            Legen Sie fest, bis wann dieser Ordner nur für eine bestimmte Benutzergruppe sichtbar ist.
            Ab dem eingestellten Datum ist er für alle Benutzer sichtbar.
          </Typography>

          <TextField
            label="Öffentlich ab (Datum)"
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={visibilityFrom}
            onChange={(e) => this.setState({ visibilityFrom: e.target.value })}
            style={{ marginBottom: 16 }}
          />

          <FormControl fullWidth style={{ marginBottom: 16 }}>
            <InputLabel>Vorher sichtbar für Gruppe</InputLabel>
            <Select
              value={restrictedGroupId}
              onChange={(e) => this.setState({ restrictedGroupId: e.target.value })}
            >
              <MenuItem value=""><em>— Keine Einschränkung —</em></MenuItem>
              {userGroups.map((group) => {
                const nameEntry = group.names && group.names.find(n => n.lang === 'DE');
                const groupName = nameEntry ? nameEntry.value : group.id;
                return (
                  <MenuItem key={group.id} value={group.id}>{groupName}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClear} style={{ marginRight: 'auto' }}>
            Einschränkung aufheben
          </Button>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button onClick={this.handleSubmit} color="primary" variant="contained">
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

